import {Injectable} from '@angular/core';
import {LoadingSpinnerService} from './loading-spinner.service';
import {PostMessageService} from './post-message.service';
import {DialogService} from './dialog.service';
import {SnackBarService} from './snackbar.service';
import {
  DynamicConfirmationDialogComponent
} from '../components/dynamic-confirmation-dialog/dynamic-confirmation-dialog.component';
import {DocumentHal} from '../models/HAL/document-hal.model';

@Injectable({
  providedIn: 'root'
})
export class FormActionsHelperService {

  constructor(private readonly loadingSpinnerService: LoadingSpinnerService,
              private readonly postMessageService: PostMessageService,
              private readonly dialogService: DialogService,
              private readonly snackBarService: SnackBarService) {

  }

  public saveFormProgress(documentHal: DocumentHal | undefined) {
    this.loadingSpinnerService.show();
    if (documentHal) {
      const postMessage = this.postMessageService.getSaveProgressPostMessageModel(documentHal);
      const formPreviewElement = document.querySelector("#formPreview") as HTMLIFrameElement;
      if (formPreviewElement) {
        this.postMessageService.postMessage(formPreviewElement, postMessage);
      }
    } else {
      this.snackBarService.open("previewForm.saveProgressNotCompleted", 3, "error");
      this.loadingSpinnerService.hide();
    }
  }

  public completeDataCapturing(documentHal: DocumentHal | undefined) {
    this.dialogService.open(DynamicConfirmationDialogComponent, {
      data: {
        title: "previewForm.dataCapturingCompleteDialog.title",
        message: "previewForm.dataCapturingCompleteDialog.message",
        confirmButtonText: "previewForm.dataCapturingCompleteDialog.confirmButtonText",
        cancelButtonText: "previewForm.dataCapturingCompleteDialog.cancelButtonText"
      }
    }).afterClosed().subscribe((result) => {
      if (result) {
        this.loadingSpinnerService.show();
        if (documentHal) {
          const postMessage = this.postMessageService.getDataCapturingPostMessageModel(documentHal);
          this.postMessageService.postMessage(document.querySelector("#formPreview") as HTMLIFrameElement, postMessage);
        } else {
          this.snackBarService.open("previewForm.dataCapturingNotCompleted", 3, "error");
          this.loadingSpinnerService.hide();
        }
      }
    });
  }
}
